var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/lodash/_getPrototype.js
// module id = ./node_modules/recharts/node_modules/lodash/_getPrototype.js
// module chunks = 1